import {
  MainPage,
  Registration,
  ServiceCentersPage,
  ServiceCenterDetailPage,
  AppealsPage,
  ProductOrderPage,
  CompanyProductOrderPage,
  CompanyServiceOrderPage,
  EmailConfirmPage,
  MyAddressesPage,
  AppealsDetailPage,
  NoticePage,
  ReviewSuccessfulPage,
  ReviewErrorPage,
  AppealConsultation,
  TermsOfUse,
  PaymentSuccessfulPage,
  UserSettingsNoticePage,
  CompanyMagicLinkLogin,
  CompanyRegistration,
  CompanyLogin,
} from 'pages'
import { ServiceOrderPage } from 'pages/ServiceOrderPage'
import { RouteObject } from 'react-router-dom'

import { ProtectedRoute } from '../ProtectedRoute'
import { PublicRoute } from '../PublicRoute'

import { commonRoutes } from './commonRoutes'

export const lkRoutes: RouteObject[] = [
  {
    element: <PublicRoute />,
    children: [
      {
        id: 'main',
        path: '/',
        element: <MainPage />,
      },

      {
        id: 'registration',
        path: '/registration',
        element: <Registration />,
      },
      {
        id: 'company-login',
        path: '/company/login',
        element: <CompanyLogin />,
      },
      {
        id: 'company-registration',
        path: '/company/registration',
        element: <CompanyRegistration />,
      },
      {
        id: 'company-magic-link-login',
        path: '/company/email/login',
        element: <CompanyMagicLinkLogin />,
      },
      {
        id: 'servicecenters',
        path: '/servicecenters',
        element: <ServiceCentersPage />,
      },
      {
        id: 'servicecenters-id',
        path: '/servicecenters/:id',
        element: <ServiceCenterDetailPage />,
      },
      {
        id: 'productorder',
        path: '/productorder',
        element: <ProductOrderPage />,
      },
      {
        id: 'company-productorder',
        path: '/company/productorder',
        element: <CompanyProductOrderPage />,
      },
      {
        id: 'serviceorder',
        path: '/serviceorder',
        element: <ServiceOrderPage />,
      },
      {
        id: 'company-serviceorder',
        path: '/company/serviceorder',
        element: <CompanyServiceOrderPage />,
      },
      {
        id: 'emailconfirm',
        path: '/email_confirm/:token',
        element: <EmailConfirmPage />,
      },
      {
        id: 'payment-successful',
        path: '/payment-successful',
        element: <PaymentSuccessfulPage />,
      },
      {
        id: 'term-of-use',
        path: '/term-of-use',
        element: <TermsOfUse />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        id: 'appeals',
        path: '/appeals',
        element: <AppealsPage />,
      },
      {
        id: 'appeal-order',
        path: '/appeals/order/:orderId',
        element: <AppealsDetailPage type={'order'} />,
      },
      {
        id: 'appeal-lead',
        path: '/appeals/lead/:leadId',
        element: <AppealsDetailPage type={'lead'} />,
      },
      {
        id: 'appeal-consultation',
        path: '/appeals/consultation/:uid',
        element: <AppealConsultation />,
      },
      {
        id: 'myaddresses',
        path: '/myaddresses',
        element: <MyAddressesPage />,
      },
      {
        id: 'notice',
        path: '/notice',
        element: <NoticePage />,
      },
      {
        id: 'review-success',
        path: '/review-successful',
        element: <ReviewSuccessfulPage />,
      },
      {
        id: 'review-error',
        path: '/review-error',
        element: <ReviewErrorPage />,
      },
      {
        id: 'settings-notice',
        path: '/settings/notice',
        element: <UserSettingsNoticePage />,
      },
    ],
  },
  ...commonRoutes,
]
